import { useDispatch } from 'react-redux';
import { Col, Alert, Spinner, Row, Card, CardHeader, CardBody } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { createSelector } from 'reselect';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { ODataGrid } from '../../../Components/OElements/ODataGrid';
import OffcanvasContainer from "./OffcanvasContainer";
import Section from './Section';
import { getInformationRegisterSMAList } from '../../../slices/thunks';
import AddEditInformationRegisterSMAModal from './Add_Edit/AddEditInformationRegisterSMA';
import DetailInformationRegisterSMAModal from './Add_Edit/DetailInformationRegisterSMA';

const InformationRegisterSMAList = () => {
	const dispatch = useDispatch();
	const history = useNavigate();

	const selectorInformationRegisterSMA = createSelector(
		state => state.informationRegisterSMAProvider,
		register => ({
			informationRegisterSMAList: register.informationRegisterSMAList,
			isLoadingList: register.isLoadingList,
			isInformationRegisterSMASuccess: register.isInformationRegisterSMASuccess,
			error: register.error,
			isAdding: register.isAdding,
			isAdded: register.isAdded,
			isAddError: register.isAddError,
			isUpdating: register.isUpdating,
			isUpdated: register.isUpdated,
			isUpdateError: register.isUpdateError,
			isDeleting: register.isDeleting,
			isDeleted: register.isDeleted,
			isDeleteError: register.isDeleteError,
		})
	);

	const { informationRegisterSMAList, isLoadingList, } = useSelector(selectorInformationRegisterSMA);

	const [dataInformationRegisterSMA, setDataInformationRegisterSMA] = useState({});
	const [isEdit, setIsEdit] = useState(false);

	// Delete InformationRegisterSMA
	const [modal, setModal] = useState(false);
	const [modalDetail, setModalDetail] = useState(false);
	const [modalFilesInformationRegisterSMA, setModalFilesInformationRegisterSMA] = useState(false);
	const [modalDelete, setModalDelete] = useState(false);
	//Tab
	const [activeTab, setActiveTab] = useState('1');
	const toggleTab = tab => {
		if (activeTab !== tab) {
			setActiveTab(tab);
		}
	};

	function handleToggleModal() {
		setModal(!modal);
	}

	function handleToggleModalDetail() {
		setModalDetail(!modalDetail);
	}

	function handleToggleModalFilesInformationRegisterSMA() {
		setModalFilesInformationRegisterSMA(!modalFilesInformationRegisterSMA);
	}

	// Update Data
	const handleClickEdit = register => {
		setDataInformationRegisterSMA(register);
		handleToggleModal();
	};


	// Offcanvas container states
	const [isRight, setIsRight] = useState(false);
	const [filters, setFilters] = useState({
		dateRange: [],
		establishment: null,
		code_siep: null
	});

	useEffect(() => {
		dispatch(getInformationRegisterSMAList({ ...filters }));
	}, [filters]);

	const columns = useMemo(
		() => [
			{
				header: 'Acciones', enableSorting: false, enableColumnFilter: false, enableGlobalFilter: false, enableColumnActions: false,
				accessorKey: 'register',
				columnDefType: 'display',
				size: 'auto',
				Cell: cellProps => {
					return (
						<React.Fragment>
							<div className='d-flex'>
								<div className='flex-shrink-0'>
									<ul className='list-inline mb-0'>
										<li className='list-inline-item'>
											<Link
												to='#'
												onClick={() => {
													const dataData = cellProps.row.original;
													handleToggleModalDetail();
													setDataInformationRegisterSMA(dataData);
												}}
											>
												<i className='ri-router-line align-bottom me-2 text-muted'></i>
											</Link>
										</li>
									</ul>
								</div>
							</div>
						</React.Fragment>
					);
				},
			},
			{ header: 'Unidad Fiscalizable Id', accessorKey: 'ufid' },
			{ header: 'Siep', accessorKey: 'siep_code' },
			{ header: 'Proveedor', accessorKey: 'provider' },
			{ header: 'Fecha Envío', accessorKey: 'fecha_envio_catastro', dataType: 'datetime' },
			{ header: 'Nombre', accessorKey: 'nombre' },
			{ header: 'Rut', accessorKey: 'rut' },
			{ header: 'Comuna', accessorKey: 'comuna' },
			{ header: 'Región', accessorKey: 'region' },
			{ header: 'Contacto', accessorKey: 'contacto' },
			{ header: 'Correo', accessorKey: 'correo' },
			{ header: 'Responsable', accessorKey: 'nombre_responsable' },
			{ header: 'Correo Responsable', accessorKey: 'correo_responsable' },
			{ header: 'Inicio Ciclo Productivo', accessorKey: 'cycle_start', dataType: 'date' },
			{ header: 'Término Ciclo Productivo', accessorKey: 'cycle_end', dataType: 'date' },

		],
		[handleClickEdit]
	);


	return (
		<React.Fragment>
			<Row>
				<Col lg={12}>
					<Card>
						{/* <CardHeader className="border-0 pb-0">
							<Section rightCanvasBtn={toggleRightCanvas} />
							<OffcanvasContainer
								isOpen={isRight}
								toggle={toggleRightCanvas}
								filters={filters}
								onSubmit={handleFiltersSubmit}
							/>

							<div className='d-flex align-items-end justify-content-end'>
								<div className='flex-shrink-0'>
									<div className='d-flex flex-wrap gap-2'>
										<button
											className='btn btn-label btn-primary'
											onClick={() => {
												setIsEdit(false);
												handleToggleModal();
											}}
										>
											<i className={`${Icons.plus} label-icon`}></i>{' '}
											Catastro
										</button>
									</div>
								</div>
							</div>
						</CardHeader> */}


						<CardBody>
							<ODataGrid
								columns={columns}
								data={informationRegisterSMAList || []}
								isLoadingData={isLoadingList}
								nameFile={'catastros'}
								customToolbarActions={[
									{
										label: 'Crear',
										icon: Icons.plus,
										onClick: () => {
											setIsEdit(false);
											handleToggleModal();
										},
										title: 'Crear Catastro',
									}
								]}
							/>
						</CardBody>
					</Card>
				</Col>
			</Row>

			<AddEditInformationRegisterSMAModal
				dataInformationRegisterSMA={dataInformationRegisterSMA}
				isEdit={isEdit}
				isOpen={modal}
				handleToggleModal={handleToggleModal}
				activeTab={activeTab}
				toggleTab={toggleTab}
			/>


			<DetailInformationRegisterSMAModal
				dataInformationRegisterSMA={dataInformationRegisterSMA}
				isOpen={modalDetail}
				handleToggleModalDetail={handleToggleModalDetail}
			/>

		</React.Fragment>
	);
};

export default InformationRegisterSMAList;
